<template>
<v-card height='100%'>
  <v-card-title class='subtitle-1 overline grey lighten-4' >
    <v-avatar :size=24 color='primary' class='mr-2 white--text' >
      <span>1</span>
    </v-avatar>
    Get set up
    <v-spacer/>
    <v-progress-circular :value='progress' color='amber' width='2' >
      {{progress}}
    </v-progress-circular>
  </v-card-title>
  <v-divider/>
  <!-- {{currentIndex}} -->
  <v-timeline dense clipped >
    <template v-for="item in timeline.items" >
      <v-timeline-item small
        :key="item.text"
        :icon="item.done ? 'mdi-check' : 'mdi-record'"
        :color="item.done ? 'success' : 'info'" >
        <v-row justify="space-between" >
          <v-col class='caption' >
            {{item.text}}
          </v-col>
          <v-col class='text-right'>

            <v-btn
              :color="item.done ? 'gray' : 'primary'"
              v-on="item.on"
              class='mt-1 mr-1 pr-0' outlined small text >Start
              <v-divider vertical class='ml-1' />
              <v-menu offset-y left >
                <template v-slot:activator="{ on }">
                <v-btn
                  @click.prevent='noop'
                  v-on='on' slot='activator' small icon class='ma-0' >
                  <v-icon x-small>mdi-arrow-down</v-icon>
                </v-btn>
                </template>
                <v-list dense class='pa-0'>
                  <v-list-item >
                    <v-list-item-content>
                      <v-list-item-title>Mark as done</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item >
                    <v-list-item-content>
                      <v-list-item-title>Skip</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-btn>
          </v-col>
        </v-row>
      </v-timeline-item>
    </template>

    <!-- <v-timeline-item small color="grey" class='text-right' >
      <v-spacer/>

    </v-timeline-item> -->
  </v-timeline>
  <v-divider />
  <v-card-actions >
    <v-spacer/>
    <v-btn small text >Next: Getting started
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'Onboarder',
  props: {
    level: { type: String, default: 'gettingsetup' }
  },
  data () {
    return {
      timelines: {
        gettingsetup: {
          title: 'Getting Setup',
          items: [
            {
              text: 'Create a space',
              done: true,
              on: {
                click: () => {
                  this.launchNewSpaceWizard()
                }
              }
            },
            {
              text: 'Configure your locations',
              done: false,
              on: {
                click: () => {
                  this.launchNewLocationWizard()
                }
              }
            },
            {
              text: 'Configure your appointment types',
              done: false,
              on: {
                click: () => {
                  this.launchQuickCreateAppointmentType()
                }
              }
            },
            {
              text: 'Add your Team',
              done: false,
              on: {
                click: () => {
                  this.launchInviteWizard()
                }
              }
            }
          ]
        },
        gettingstarted: {
          title: 'Getting Started',
          items: [
            {
              text: 'Create your first apopintment',
              done: true
            },
            {
              text: 'Create your first invoice',
              done: true
            }
          ]
        },
        automate: {
          title: 'Automate repetitive tasks',
          items: [
            {
              text: 'Automating intake forms with Jotform',
              done: false
            },
            {
              text: 'Automate ICD-10 coding with Treatment plans',
              done: false
            }
          ]
        }
      }
    }
  },
  methods: {
    noop () {
      console.log('noop')
    },
    launchWizard (item) {
      console.log(item)
    }
  },
  computed: {
    currentIndex () {
      return Object.keys(this.timelines)
    },
    timeline () {
      return this.timelines[this.level]
    },
    progress () {
      return Math.round(Math.random()*100)
    }
  }
}
</script>
